import { render, staticRenderFns } from "./about-swiper.vue?vue&type=template&id=4a5dc2e2"
import script from "./about-swiper.vue?vue&type=script&lang=js"
export * from "./about-swiper.vue?vue&type=script&lang=js"
import style0 from "./about-swiper.vue?vue&type=style&index=0&id=4a5dc2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports